import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function PageTitle({ title, className, subtitle = '', children = null, backBtn = '' }) {
  const classes = classNames(className, 'text-center', 'text-md-start');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (backBtn === true) {
      navigate(-1);
    } else {
      navigate(backBtn);
    }
  };

  return (
    <Col className={classes}>
      {subtitle && <span className="text-uppercase page-subtitle">{subtitle}</span>}
      <div className="d-block d-md-flex">
        <h1 className="page-title mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start align-items-center">
          <span>{title}</span>
        </h1>
        {(children || backBtn) !== '' && (
          <div className="my-3 my-md-0 ms-sm-auto d-block d-md-flex align-items-center">
            {children}
            {backBtn === '' || (
              <Button variant="outline-light" className="back text-info" onClick={handleClick}>
                {t('common:buttons.back')}
              </Button>
            )}
          </div>
        )}
      </div>
    </Col>
  );
}

PageTitle.propTypes = {
  /**
   * The page title.
   */
  title: PropTypes.string.isRequired,
  /**
   * The url for the back button or a boolean which will default to navigate(-1).
   */
  backBtn: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * The page subtitle.
   */
  subtitle: PropTypes.string,
  /**
   * The children components.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PageTitle;
